import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/waitlist/page.tsx");
